// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppSmartBanner-bar-eZTJ2 {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;
  border-top: 1px solid #f0e0e0;
  -webkit-box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.08);
          box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.08);
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  font-family: 'Poppins', system-ui, -apple-system, sans-serif;
  -webkit-animation: AppSmartBanner-bhslideup-jCkZz 0.25s ease-out;
          animation: AppSmartBanner-bhslideup-jCkZz 0.25s ease-out;
}

@-webkit-keyframes AppSmartBanner-bhslideup-jCkZz {
  from { -webkit-transform: translateY(100%); transform: translateY(100%); }
  to { -webkit-transform: translateY(0); transform: translateY(0); }
}

@keyframes AppSmartBanner-bhslideup-jCkZz {
  from { -webkit-transform: translateY(100%); transform: translateY(100%); }
  to { -webkit-transform: translateY(0); transform: translateY(0); }
}

.AppSmartBanner-close-MggQl {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  width: 26px;
  height: 26px;
  border: none;
  background: #f3eded;
  color: #6b7280;
  border-radius: 50%;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.AppSmartBanner-logo-qRHZj {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  width: 44px;
  height: 44px;
  border-radius: 11px;
  background: #d32f2f;
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.AppSmartBanner-txt-Oe7ut { -webkit-box-flex: 1; -ms-flex: 1 1; flex: 1 1; min-width: 0; }

.AppSmartBanner-title-juJu5 {
  font-size: 14px;
  font-weight: 800;
  color: #1f2733;
  line-height: 1.2;
}

.AppSmartBanner-sub-lMVka {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.AppSmartBanner-cta-Gggad {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  background: #d32f2f;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 13.5px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppSmartBanner/AppSmartBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,mDAA2C;UAA3C,2CAA2C;EAC3C,gEAAgE;EAChE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,4DAA4D;EAC5D,gEAAmC;UAAnC,wDAAmC;AACrC;;AAEA;EACE,OAAO,mCAA2B,EAA3B,2BAA2B,EAAE;EACpC,KAAK,gCAAwB,EAAxB,wBAAwB,EAAE;AACjC;;AAHA;EACE,OAAO,mCAA2B,EAA3B,2BAA2B,EAAE;EACpC,KAAK,gCAAwB,EAAxB,wBAAwB,EAAE;AACjC;;AAEA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA,4BAAO,mBAAO,EAAP,aAAO,EAAP,SAAO,EAAE,YAAY,EAAE;;AAE9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: #fff;\n  border-top: 1px solid #f0e0e0;\n  box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.08);\n  padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-family: 'Poppins', system-ui, -apple-system, sans-serif;\n  animation: bhslideup 0.25s ease-out;\n}\n\n@keyframes bhslideup {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n.close {\n  flex: none;\n  width: 26px;\n  height: 26px;\n  border: none;\n  background: #f3eded;\n  color: #6b7280;\n  border-radius: 50%;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.logo {\n  flex: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 11px;\n  background: #d32f2f;\n  color: #fff;\n  font-weight: 800;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.txt { flex: 1; min-width: 0; }\n\n.title {\n  font-size: 14px;\n  font-weight: 800;\n  color: #1f2733;\n  line-height: 1.2;\n}\n\n.sub {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cta {\n  flex: none;\n  background: #d32f2f;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 13.5px;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `AppSmartBanner-bar-eZTJ2`,
	"bhslideup": `AppSmartBanner-bhslideup-jCkZz`,
	"close": `AppSmartBanner-close-MggQl`,
	"logo": `AppSmartBanner-logo-qRHZj`,
	"txt": `AppSmartBanner-txt-Oe7ut`,
	"title": `AppSmartBanner-title-juJu5`,
	"sub": `AppSmartBanner-sub-lMVka`,
	"cta": `AppSmartBanner-cta-Gggad`
};
module.exports = ___CSS_LOADER_EXPORT___;
